import type { ScreenplayEditorBlock } from './screenplayEditor';
import { insertInlineMarker } from './inlinePauses';
import { POINT_VOCAL_CUES, markerLabel } from './inlineMarkers';
export { POINT_VOCAL_CUES } from './inlineMarkers';

export function insertInlineVocalCue(block: ScreenplayEditorBlock, offset: number, cue: string) {
  if (!(POINT_VOCAL_CUES as readonly string[]).includes(cue)) throw new Error('Unsupported vocal cue.');
  const {block:updated,marker}=insertInlineMarker(block,offset,`{${markerLabel(cue)}}`,{cueMarker:true,cue,unspoken:true});
  return {block:updated,start:marker.start,end:marker.end};
}
